import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import * as Resize from 'iframe-resizer';
import router from './router'
import store from './store/index'
import {Vuelidate} from "vuelidate";
import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'
import Helpers from "./models/Helpers";
import LoadScript from 'vue-plugin-load-script';

Vue.prototype.$helpers = Helpers;
Vue.config.productionTip = false;

Vue.use(Vuelidate);
Vue.use(Resize);
Vue.use(LoadScript);

Vue.filter('toCurrency', function (value) {
    if (typeof value !== "number") {
        return value;
    }
    var formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2
    });
    return formatter.format(value);
});


const requireComponent = require.context(
  // The relative path of the components folder
  './components/fields',
  // Whether or not to look in subfolders
  false,
  // The regular expression used to match base component filenames
  /[A-Z]\w+\.(vue|js)$/,
);

requireComponent.keys().forEach((fileName) => {
  // Get component config
  const componentConfig = requireComponent(fileName);

  // Get PascalCase name of component
  const componentName = upperFirst(
    camelCase(
      // Strip the leading `./` and extension from the filename
      fileName.replace(/^\.\/(.*)\.\w+$/, '$1'),
    ),
  );

  // Register component globally
  Vue.component(
    componentName,
    // Look for the component options on `.default`, which will
    // exist if the component was exported with `export default`,
    // otherwise fall back to module's root.
    componentConfig.default || componentConfig,
  );
});


Vue.component('vuejsDatepicker');

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
